import { createClient } from "@supabase/supabase-js";

export const supabaseClient = createClient(
  process.env.REACT_APP_SUPABASE_URL || "your-supabase-url",
  process.env.REACT_APP_SUPABASE_ANON_KEY || "your-supabase-anon-key"
);
